import { render, staticRenderFns } from "./toast-notification.vue?vue&type=template&id=1221c234&scoped=true&lang=pug"
import script from "./toast-notification.js?vue&type=script&lang=js&external"
export * from "./toast-notification.js?vue&type=script&lang=js&external"
import style0 from "./toast-notification.vue?vue&type=style&index=0&id=1221c234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221c234",
  null
  
)

export default component.exports